import React, {useEffect, useState} from "react";
export const TranslateContext = React.createContext();

export const TranslateProvider = ({value, children}) => {

    const [lang, setLang] = useState(value)
    const [loadingNewLang, setLoadingNewLang] = useState(false)
    const [translations, setTranslations] = useState([])

    useEffect(() => {
        setLang(value)
        loadTranslations(value);
    }, [])

    async function loadTranslations(lang) {
        const response = await fetch(`/i18n/translactions-${lang}.json`);
        let data = await response.json();

        const responseExt = await fetch(`/i18n/translactions-ext-${lang}.json`);
        if (responseExt.ok && responseExt.headers.get('Content-Type') === 'application/json') {
            const dataExt = await responseExt.json();
            data = { ...data, ...dataExt };
        }

        setTranslations(data);
    }

    const setLingua = (lingua) => {
        localStorage.setItem('sost-lang', lingua);
        loadTranslations(lingua);
        setLoadingNewLang(true);
        setLang(lingua)
    }

    const translate = (testo) => {
        return translations[testo] && translations[testo]['msgstr'] || testo
    }

    return (
        <TranslateContext.Provider
            value={{lingua: lang, setLingua, translate: translate, loadingNewLang, setLoadingNewLang}}>{children}</TranslateContext.Provider>
    );
};
